// extracted by mini-css-extract-plugin
export var chevron = "_95-2";
export var dropdownItems = "_95-0";
export var item = "_95-1";